import { create } from 'zustand';

const STORAGE_KEY = 'pebbl_admin_token';

interface AuthState {
  token: string | null;
  /** true when the last token was cleared by a 401 (shows "token rejected") */
  rejected: boolean;

  // Actions
  setToken: (token: string) => void;
  clearToken: (rejected?: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: sessionStorage.getItem(STORAGE_KEY),
  rejected: false,

  setToken: (token) => {
    sessionStorage.setItem(STORAGE_KEY, token);
    set({ token, rejected: false });
  },

  clearToken: (rejected = false) => {
    sessionStorage.removeItem(STORAGE_KEY);
    set({ token: null, rejected });
  },
}));
